import React, { useEffect, useRef, useState } from 'react';
import { Input } from '@/components/ui/input';

const AddressAutocomplete = ({ value, onChange, placeholder, className, onLocationSelect, onPlaceSelect, ...props }) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [isSelectingPlace, setIsSelectingPlace] = useState(false);

  useEffect(() => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.log('Google Maps API not loaded, using regular input');
      return;
    }

    try {
      autocompleteRef.current = new window.google.maps.places.Autocomplete(
        inputRef.current,
        {
          componentRestrictions: { country: 'za' },
          fields: ['formatted_address', 'address_components', 'geometry'],
          types: ['address']
        }
      );

      autocompleteRef.current.addListener('place_changed', () => {
        const place = autocompleteRef.current.getPlace();

        if (place && place.formatted_address) {
          setIsSelectingPlace(true);

          onChange({
            target: { name: props.name, value: place.formatted_address }
          });

          if (inputRef.current) {
            inputRef.current.value = place.formatted_address;
          }

          if (onLocationSelect && place.geometry && place.geometry.location) {
            onLocationSelect({
              address: place.formatted_address,
              latitude: place.geometry.location.lat(),
              longitude: place.geometry.location.lng()
            });
          }

          if (onPlaceSelect) {
            onPlaceSelect(place);
          }

          setTimeout(() => setIsSelectingPlace(false), 200);
        }
      });
    } catch (error) {
      console.log('Google Places autocomplete initialization failed:', error);
    }

    return () => {
      if (autocompleteRef.current && window.google?.maps?.event) {
        window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
      }
    };
  }, [onChange, props.name, onLocationSelect]);

  useEffect(() => {
    if (inputRef.current && value && !isSelectingPlace) {
      inputRef.current.value = value;
    }
  }, [value, isSelectingPlace]);

  const handleInputChange = (e) => {
    if (!isSelectingPlace) onChange(e);
  };

  return (
    <Input
      ref={inputRef}
      value={value}
      onChange={handleInputChange}
      placeholder={placeholder}
      className={className}
      autoComplete="off"
      {...props}
    />
  );
};

export default AddressAutocomplete;
